import { Widget } from '@sprinklr/stories/widget/Widget';
import _cloneDeep from 'lodash/cloneDeep';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';

// this replaces the position of the widget with the default position for a panel template
export function getWidgetAsPanelTemplate(widgetTemplate: Widget) {
    const widget = _cloneDeep(widgetTemplate);
    widget.position = DefaultPosition;
    return widget;
}
